<template>
  <v-dialog :value="value" max-width="560" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>
        <v-icon color="warning" class="me-2">mdi-alert-outline</v-icon>
        <span class="text-h6">{{ title }}</span>
      </v-card-title>

      <v-card-subtitle class="pt-2">
        {{ $t('bulk_kept_explanation', { count: failures.length }) }}
      </v-card-subtitle>

      <v-card-text style="max-height: 380px; overflow-y: auto">
        <v-list dense>
          <v-list-item v-for="(failure, i) in failures" :key="i">
            <v-list-item-content>
              <v-list-item-title>{{ failure.name }}</v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ failure.reason }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('input', false)">
          {{ $t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*
 * Lists the rows a bulk run could not process, each with the reason the server
 * gave. Shown only when something was actually kept back.
 */
export default {
  name: "BulkResultDialog",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "" },
    failures: { type: Array, default: () => [] },
  },
};
</script>
